"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerPaymentMethodHandler = void 0;
const React = require("react");
const react_1 = require("react");
const CustomerPaymentMethodContext_1 = require("../../contexts/CustomerPaymentMethodContext");
const RetailLocationsContext_1 = require("../../contexts/RetailLocationsContext");
const useFetchCustomerPaymentMethod_1 = require("../../hooks/useFetchCustomerPaymentMethod");
const useUpdateCustomerPaymentMethod_1 = require("../../hooks/useUpdateCustomerPaymentMethod");
const useClient_1 = require("../../../../../hooks/useClient");
const deleteUpdateCustomerPaymentMethod_1 = require("../../hooks/deleteUpdateCustomerPaymentMethod");
const CustomerPaymentMethodHandler = ({ children, errorApproach = "modal" }) => {
    const client = (0, useClient_1.useClient)();
    const { retailLocation } = (0, react_1.useContext)(RetailLocationsContext_1.RetailLocationsContext);
    const [paymentMethod, setPaymentMethod] = (0, react_1.useState)(null);
    const retailCustomerId = (0, react_1.useMemo)(() => client.auth.session &&
        client.auth.session.retailCustomer &&
        client.auth.session.retailCustomer.id, [client.auth.session]);
    const gatewayId = (0, react_1.useMemo)(() => retailLocation && retailLocation.paymentGatewayId, [retailLocation]);
    const { paymentMethod: paymentMethodFetch, refetch: fetchPaymentMethod, isLoading: isLoadingPaymentMethodFetch, error: errorPaymentMethodFetch } = (0, useFetchCustomerPaymentMethod_1.useFetchCustomerPaymentMethod)(retailCustomerId, gatewayId, errorApproach);
    const { mutate: updatePaymentMethod, isLoading: isLoadingPaymentMethodUpdate, error: errorPaymentMethodUpdate } = (0, useUpdateCustomerPaymentMethod_1.useUpdateCustomerPaymentMethod)(retailCustomerId, errorApproach, {
        onSuccess: (data) => {
            setPaymentMethod(data);
        }
    });
    const { mutate: deletePaymentMethod, isLoading: isLoadingPaymentMethodDelete, error: errorPaymentMethodDelete } = (0, deleteUpdateCustomerPaymentMethod_1.useDeleteCustomerPaymentMethod)(retailCustomerId, errorApproach, {
        onSuccess: () => {
            setPaymentMethod(null);
        }
    });
    const isLoading = (0, react_1.useMemo)(() => ({
        fetch: isLoadingPaymentMethodFetch,
        update: isLoadingPaymentMethodUpdate,
        delete: isLoadingPaymentMethodDelete
    }), [isLoadingPaymentMethodFetch, isLoadingPaymentMethodUpdate]);
    const errors = (0, react_1.useMemo)(() => ({
        fetch: errorPaymentMethodFetch,
        update: errorPaymentMethodUpdate,
        delete: errorPaymentMethodDelete
    }), [errorPaymentMethodFetch, errorPaymentMethodUpdate]);
    (0, react_1.useEffect)(() => {
        if (retailCustomerId) {
            fetchPaymentMethod();
        }
        else {
            setPaymentMethod(null);
        }
    }, [retailCustomerId, gatewayId]);
    (0, react_1.useEffect)(() => {
        setPaymentMethod(paymentMethodFetch);
    }, [paymentMethodFetch]);
    const provider = (0, react_1.useMemo)(() => ({
        paymentMethod,
        setPaymentMethod,
        isLoading,
        errors,
        fetchPaymentMethod,
        updatePaymentMethod,
        deletePaymentMethod
    }), [
        paymentMethod,
        setPaymentMethod,
        isLoading,
        errors,
        fetchPaymentMethod,
        updatePaymentMethod,
        deletePaymentMethod
    ]);
    return (React.createElement(CustomerPaymentMethodContext_1.CustomerPaymentMethodContext.Provider, { value: provider }, children));
};
exports.CustomerPaymentMethodHandler = CustomerPaymentMethodHandler;
//# sourceMappingURL=index.js.map